import * as Sentry from "@sentry/react";
import { CONFIG } from "./config";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE as number,
  environment: CONFIG.APP_STAGE,
  enabled: ["production", "staging"].includes(CONFIG.APP_STAGE),
});
